var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"StandardSmallBorderedButton",class:[{ disabled: _vm.disabled, fluid: _vm.fluid }, _vm.color],on:{"click":function($event){return _vm.emitClick()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }